import React from 'react';
export function SectionDivider() {
  return <div className="w-full py-10 flex items-center justify-center opacity-80" aria-hidden="true" data-id="element-328">
      <div className="flex items-center gap-6 text-gold-600 font-mono text-xs tracking-[0.3em]" data-id="element-329">
        <span className="text-gold-500" data-id="element-330">✦</span>
        <div className="h-px w-32 md:w-64 bg-gradient-to-r from-gold-700/50 to-transparent" data-id="element-331"></div>
        <span className="text-gold-400/50 uppercase" data-id="element-332">Exclusive Access</span>
        <div className="h-px w-32 md:w-64 bg-gradient-to-l from-gold-700/50 to-transparent" data-id="element-333"></div>
        <span className="text-gold-500" data-id="element-334">✦</span>
      </div>
    </div>;
}